<template>
  <div
    class="zg-tips-line"
    :class="{ 'zg-tips-line-small': isSmall }"
  >
    <figure
      v-for="({ image, title, text }, index) in tips"
      :key="`tip-${index}`"
      class="tip"
    >
      <div
        class="tip__image"
      >
        <zg-image
          v-if="image"
          :alt="image.title"
          :src="image.src"
          lazy-load
        />
      </div>

      <figcaption
        class="tip__text"
      >
        <h3
          v-if="title"
        >
          {{ title }}
        </h3>

        <p
          v-if="text"
          v-html="text"
        />
      </figcaption>
    </figure>
  </div>
</template>

<script>
  import ZgImage from '../ZgImage/ZgImage'

  export default {
    name: 'ZgTipsLine',
    components: { ZgImage },
    props: {
      tips: {
        type: Array,
        required: true,
        default: () => ([])
      },
      size: {
        type: String,
        default: 'large',
        validator: value => [
          'large',
          'small'
        ].includes(value)
      }
    },
    computed: {
      isSmall () {
        return this.size === 'small'
      }
    }
  }
</script>

<style lang="scss" scoped>
.zg-tips-line {
  display: flex;
  flex-direction: column;
  gap: rhythm(double);

  .tip {
    display: flex;
    flex-direction: column;
    gap: rem(24px);

    @include mq(medium) {
      flex-direction: row;
    }

    &__image {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: rem(160px);
      height: rem(160px);
      border-radius: radius(small);
      overflow: hidden;

      ::v-deep img {
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
      }
    }

    &__text {
      ::v-deep p:last-child {
        margin: 0;
      }
    }
  }

  &-small {
    margin: 0 rhythm();
    padding: rhythm();
    border-radius: rhythm();
    background-color: color(brand-100);

    @include mq(large) {
      margin: 0;
      padding: 0;
    }

    h3 {
      margin-bottom: 0.25rem;
    }

    .tip {
      align-items: flex-start;
      flex-direction: row;

      &__image {
        display: unset;
        width: rem(80px);
        height: auto;

        @include mq(large) {
          width: rem(100px);
        }

        ::v-deep img {
          object-fit: unset;
        }
      }
    }
  }
}
</style>
